import * as Yup from "yup";
export const validationForOffer = (
  state,
  isEdit,
  isClone,
  disableValidityInGrantOne,
  disableValidityInGrantRecurring
) => {
  let validationSchema = {};
  validationSchema.grants = Yup.array().of(
    Yup.object().shape({
      resourceType: Yup.object().required("Select Resource Name"),
      resourceValue: Yup.number().required("Enter Resource Value"),
      validityStartsOn: Yup.mixed().test(
        "validityStartsOn-required",
        "Select Validity Starts",
        function (value) {
          const { path, parent } = this;
          const index = parseInt(path.match(/\d+/)[0], 10);

          if (!disableValidityInGrantOne[index]) {
            return value
              ? true
              : this.createError({ message: "Select Validity Starts" });
          }
          return true;
        }
      ),
      validityEndsOn: Yup.mixed().test(
        "validityEndsOn-required",
        "Select Validity Ends",
        function (value) {
          const { path, parent } = this;
          const index = parseInt(path.match(/\d+/)[0], 10);

          if (!disableValidityInGrantOne[index]) {
            return value
              ? true
              : this.createError({ message: "Select Validity Ends" });
          }
          return true;
        }
      ),
    })
  );

  validationSchema.recurringGrants = Yup.array().of(
    Yup.object().shape({
      resourceType: Yup.object().required("Select Resource Name"),
      resourceValue: Yup.number().required("Enter Resource Value"),
      cycleAlignment: !isEdit
        ? Yup.object().required("Select Cycle Alignment")
        : Yup.object(),
      recurringFrequencyUnit: Yup.number()
        .required("Enter Recurring Frequency Unit")
        .max(
          365,
          "Recurring Frequency Unit should be lesser than or equal to 365"
        ),
      validityStartsOn: Yup.mixed().test(
        "validityStartsOn-required",
        "Select Validity Starts",
        function (value) {
          const { path, parent } = this;
          const index = parseInt(path.match(/\d+/)[0], 10);

          if (!disableValidityInGrantRecurring[index]) {
            return value
              ? true
              : this.createError({ message: "Select Validity Starts" });
          }
          return true;
        }
      ),
      validityEndsOn: Yup.mixed().test(
        "validityEndsOn-required",
        "Select Validity Ends",
        function (value) {
          const { path, parent } = this;
          const index = parseInt(path.match(/\d+/)[0], 10);

          if (!disableValidityInGrantRecurring[index]) {
            return value
              ? true
              : this.createError({ message: "Select Validity Ends" });
          }
          return true;
        }
      ),
      rollover: !isEdit
        ? Yup.mixed().test(
            "validate-grants",
            "Enter the Rollover Details",
            function (value) {
              const { rolloverModel } = this.parent;
              if (
                value &&
                (rolloverModel.rolloverAmount === "" ||
                  rolloverModel.rolloverCycle === "")
              ) {
                return false;
              }
              return true;
            }
          )
        : Yup.mixed(),
      // rolloverModel: Yup.object().shape({
      //   rolloverAmount: Yup.mixed().required("Kindly enter the Maximum amount for rollover"),
      //   rolloverCycle: Yup.mixed().required("Kindly enter the Maximum cycle for rollover"),
      // })
      rolloverModel: Yup.object().shape({
        rolloverAmount: Yup.mixed().test(
          "required-if-rollover-enabled",
          "Enter Maximum Rollover Amount",
          function (value) {
            const rollover = this.from[1]?.value?.rollover;
            return !rollover || (rollover && value);
          }
        ),
        rolloverCycle: Yup.mixed().test(
          "required-if-rollover-enabled",
          "Enter Maximum Rollover Cycle",
          function (value) {
            const rollover = this.from[1]?.value?.rollover;
            return !rollover || (rollover && value);
          }
        ),
      }),
    })
  );
  validationSchema.balanceImpacts = Yup.array().of(
    Yup.object().shape({
      resourceName: Yup.mixed().required("Select Resource Name"),
      flatRate: Yup.number().required("Enter Flat Rate"),
      pricingModel: Yup.mixed().required("Select Pricing Model"),

      // pricingModelNew: Yup.array().test(
      //   "validate-tier-details-if-volume",
      //   "Kindly enter the Tier details",
      //   function (value) {
      //     const { pricingModel } = this.parent;
      //     if (pricingModel.value === "volume") {
      //       if (!Array.isArray(value) || value.length === 0) return false;

      //       return value.every(
      //         (item) =>
      //           item.startingUnit &&
      //           item.endingUnit &&
      //           item.pricePerUnit
      //       );
      //     }
      //     return true;
      //   }
      // ),

      validityStart: Yup.mixed().required("Select Validity Starts"),

      startDateTime: Yup.mixed()
        .nullable()
        .test(
          "required-if-validityStart-is-3",
          "Select Start Date and Time",
          function (value) {
            const { validityStart } = this.parent;
            if (validityStart === 3) return !!value;
            return true;
          }
        ),

      timeUnit: Yup.mixed()
        .nullable()
        .test(
          "required-if-validityEnd-is-1",
          "Select Time Unit",
          function (value) {
            const { validityEnd } = this.parent;
            if (validityEnd === 1) return !!value;
            return true;
          }
        ),

      timeValue: Yup.mixed()
        .nullable()
        .test(
          "required-if-validityEnd-is-1",
          "Enter Time Value",
          function (value) {
            const { validityEnd } = this.parent;
            if (validityEnd === 1) return !!value;
            return true;
          }
        ),

      // perUnitRate: Yup.mixed()
      //   .nullable()
      //   .test(
      //     "required-if-pricingModel-is-fixed",
      //     "Kindly enter per unit rate",
      //     function (value) {
      //       const { pricingModel } = this.parent;
      //       if (pricingModel.value === 'threshold') return !!value;
      //       return true;
      //     }
      //   ),

      validityEnd: Yup.mixed().required("Select Validity Ends"),

      endDateTime: Yup.mixed()
        .nullable()
        .test(
          "required-if-validityEnd-is-2",
          "Select End Date and Time",
          function (value) {
            const { validityEnd } = this.parent;
            if (validityEnd === 2) return !!value;
            return true;
          }
        ),
    })
  );

  const getBalanceImpactsRecurring = (type) =>
    Yup.array().of(
      Yup.object().shape({
        resourceName: Yup.mixed().required("Select Resource Name"),
        flatRate: Yup.number().required("Enter Flat Rate"),
        pricingModel: Yup.mixed().required("Select Pricing Model"),

        recurringFrequencyUnit: Yup.number()
          .nullable()
          .test(
            "required-if-type-2",
            "Enter Recurring Frequency Unit",
            function (value) {
              if (type == 2) {
                return value !== null && value !== undefined && value !== "";
              }
              return true;
            }
          )
          .max(365, "Recurring Frequency Unit should be ≤ 365"),

        cycleAlignment: Yup.mixed()
          .nullable()
          .test(
            "required-if-type-2",
            "Select Cycle Alignment",
            function (value) {
              if (type == 2) {
                return value !== null && value !== undefined && value !== "";
              }
              return true;
            }
          ),

        recurringFrequency: Yup.mixed()
          .nullable()
          .test(
            "required-if-type-2",
            "Select Recurring Frequency",
            function (value) {
              if (type == 2) {
                return value !== null && value !== undefined && value !== "";
              }
              return true;
            }
          ),

        validityStart: Yup.mixed().required("Select Validity Starts"),

        startDateTime: Yup.mixed()
          .nullable()
          .test(
            "required-if-validityStart-is-3",
            "Select Start Date and Time",
            function (value) {
              const { validityStart } = this.parent;
              if (validityStart === 3) return !!value;
              return true;
            }
          ),

        timeUnit: Yup.mixed()
          .nullable()
          .test(
            "required-if-validityEnd-is-1",
            "Select Time Unit",
            function (value) {
              const { validityEnd } = this.parent;
              if (validityEnd === 1) return !!value;
              return true;
            }
          ),

        timeValue: Yup.mixed()
          .nullable()
          .test(
            "required-if-validityEnd-is-1",
            "Enter Time Value",
            function (value) {
              const { validityEnd } = this.parent;
              if (validityEnd === 1) return !!value;
              return true;
            }
          ),

        perUnitRate: Yup.mixed()
          .nullable()
          .test(
            "required-if-pricingModel-is-fixed",
            "Enter Per Unit Rate",
            function (value) {
              const { pricingModel } = this.parent;
              if (pricingModel === "threshold") return !!value;
              return true;
            }
          ),

        validityEnd: Yup.mixed().required("Select Validity Ends"),

        endDateTime: Yup.mixed()
          .nullable()
          .test(
            "required-if-validityEnd-is-2",
            "Select End Date and Time",
            function (value) {
              const { validityEnd } = this.parent;
              if (validityEnd === 2) return !!value;
              return true;
            }
          ),
      })
    );

  validationSchema.balanceImpactsRecurring = Yup.array().of(
    Yup.object().shape({
      resourceName: Yup.mixed().required("Kindly choose a resource"),
      flatRate: Yup.number().required("Kindly enter a valid flat rate"),
      pricingModel: Yup.mixed().required("Kindly choose a pricing model"),
      recurringFrequencyUnit: Yup.number()
        .required("Kindly enter Recurring Frequency Unit")
        .max(
          365,
          "Recurring Frequency Unit should be lesser than or equal to 365"
        ),

      // pricingModelNew: Yup.array().test(
      //   "validate-tier-details-if-volume",
      //   "Kindly enter the Tier details",
      //   function (value) {
      //     const { pricingModel } = this.parent;
      //     if (pricingModel === "volume") {
      //       if (!Array.isArray(value) || value.length === 0) return false;

      //       return value.every(
      //         (item) =>
      //           !!item.startingUnit &&
      //           !!item.endingUnit &&
      //           !!item.pricePerUnit
      //       );
      //     }
      //     return true;
      //   }
      // ),

      validityStart: Yup.mixed().required("Kindly choose validity"),

      startDateTime: Yup.mixed()
        .nullable()
        .test(
          "required-if-validityStart-is-3",
          "Kindly choose start datetime",
          function (value) {
            const { validityStart } = this.parent;
            if (validityStart === 3) return !!value;
            return true;
          }
        ),

      timeUnit: Yup.mixed()
        .nullable()
        .test(
          "required-if-validityEnd-is-1",
          "Kindly choose time unit",
          function (value) {
            const { validityEnd } = this.parent;
            if (validityEnd === 1) return !!value;
            return true;
          }
        ),

      timeValue: Yup.mixed()
        .nullable()
        .test(
          "required-if-validityEnd-is-1",
          "Kindly choose time Value",
          function (value) {
            const { validityEnd } = this.parent;
            if (validityEnd === 1) return !!value;
            return true;
          }
        ),

      perUnitRate: Yup.mixed()
        .nullable()
        .test(
          "required-if-pricingModel-is-fixed",
          "Kindly enter per unit rate",
          function (value) {
            const { pricingModel } = this.parent;
            if (pricingModel === "threshold") return !!value;
            return true;
          }
        ),

      validityEnd: Yup.mixed().required("Kindly choose validity end"),

      cycleAlignment: Yup.mixed().required("Kindly choose Cycle Alignment"),

      recurringFrequency: Yup.mixed().required(
        "Kindly choose Recurring Frequency"
      ),

      endDateTime: Yup.mixed()
        .nullable()
        .test(
          "required-if-validityEnd-is-2",
          "Kindly choose end datetime",
          function (value) {
            const { validityEnd } = this.parent;
            if (validityEnd === 2) return !!value;
            return true;
          }
        ),
    })
  );

  return (validationSchema = Yup.object(
    {
      offerName: Yup.string().required("Enter Offer Name"),
      offerCode: Yup.string().required("Enter Offer Code"),
      subscriptionStartsOn:
        !state && !isEdit
          ? Yup.mixed().required("Select a value")
          : Yup.mixed(),
      subscriptionEndsOn:
        !state && !isEdit
          ? Yup.mixed().required("Select a value")
          : Yup.mixed(),
      offerStartsOn: Yup.mixed().required("Select Start Date"),
      offerEndsOn: !state && Yup.mixed().required("Select End Date"),
      serviceName: !isEdit && Yup.object().required("Select a Service"),
      grants: validationSchema.grants,
      recurringGrants: validationSchema.recurringGrants,
      charges: Yup.array().of(
        Yup.object().shape({
          resourceType: Yup.object().required("Select Resource Type"),
          resourceValue: Yup.number().required("Enter Resource Value"),
        })
      ),
      recurringCharges: Yup.array().of(
        Yup.object().shape({
          resourceType: Yup.object().required("Select Resource Type"),
          resourceValue: Yup.number().required("Enter Resource Value"),
          type: Yup.string(),
          cycleAlignment: !isEdit
            ? Yup.object().required("Select Cycle Alignment")
            : Yup.object(),
          recurringFrequency: Yup.mixed().nullable()
          .test(
            "required-if-type-2",
            "Select Recurring Frequency",
            function (value) {
              const { type } = this.parent;
              if (type == 2) {
                return value !== null && value !== undefined && value !== "";
              }
              return true;
            }
          ),
          recurringFrequencyUnit: Yup.number()
          .nullable()
          .test(
            "required-if-type-2",
            "Enter Recurring Frequency Unit",
            function (value) {
              const { type } = this.parent;
              if (type == 2) {
                return value !== null && value !== undefined && value !== "";
              }
              return true;
            }
          )
          .max(365, "Recurring Frequency Unit should be ≤ 365"),
        })
      ),
      usageRatePlan: Yup.array().of(
        Yup.object().shape({
          // usageId: Yup.number().positive('A usage id can\'t start with a minus').integer('It can\'t include a decimal point').required("Kindly enter a valid ID!"),
          eventType: Yup.string().required("Enter Usage Event Type"),
          unitOfMeasurement: Yup.mixed().required("Select Unit of Measurement"),
          priority: Yup.number()
            .positive("A priority can't start with a minus")
            .integer("It can't include a decimal point")
            .required("Enter Priority"),
          balanceImpacts: validationSchema.balanceImpacts,
        })
      ),

      recurringUsageRatePlan: Yup.array().of(
        Yup.object().shape({
          // usageId: Yup.number().positive('A usage id can\'t start with a minus').integer('It can\'t include a decimal point').required("Kindly enter a valid ID!"),
          eventType: Yup.mixed().required("Select Usage Event Type"),
          unitOfMeasurement: Yup.mixed().required("Select Unit of Measurement"),
          priority: Yup.number()
            .positive("A priority can't start with a minus")
            .integer("It can't include a decimal point")
            .required("Enter Priority"),
          type: Yup.string(),
          balanceImpacts: Yup.mixed().when("type", (type, schema) => {
            return getBalanceImpactsRecurring(type);
          }),
          // balanceImpacts: validationSchema.balanceImpactsRecurring,
        })
      ),
      effectiveAt: isEdit && Yup.mixed().required("Select Effective At"),
    },
    []
  ));
};

export const validationSchemaForImport = Yup.object().shape({
  csvFile: Yup.string().required("Select a CSV file"),
});
